// Importamos el socket
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

import { api, token, detailTicketGlobal, cargarFechaYHora } from './config.js';
import { CountUp } from './countUp.js';
import { Odometer } from './odometer.js';

//Variable de los sorteos
var draws;
var drawOpen;

//Variables para el Juego
var imgSelected = [];

//Variable temporal
var detailTicketImg = [];

var listItems = [];

//Fecha Y Hora Formateada
var formattedDateTime;

const formattingFn = (value) => value.toString().padStart(7, '0');

const options = {
  plugin: new Odometer({ duration: 2.3, lastDigitDelay: 0 }),
  duration: 1,
  separator: '',
  decimal: '',
  formattingFn: formattingFn
}
const countUp = new CountUp('jackpot', 0, options);
if (countUp.error) console.error(countUp.error);
countUp.start();

document.addEventListener("DOMContentLoaded", function() {
    //Validacion token si no existe la variabl o si esta vacia muestro el mensaje
    if(!token){
        Swal.fire({
          icon: "error",
          title: "Lo sentimos...",
          html: "<h5 style='color: white;'>Por favor vuelve a iniciar sesión</h5>",
          allowOutsideClick: false, // Evita que se hagan clics fuera del cuadro de diálogo
          showCancelButton: false,
          showConfirmButton: false,
          showDenyButton: false
        });
    }

    window.Pusher = Pusher;
    window.Echo = new Echo({
        broadcaster: 'reverb',
        key: '756e2424a06a641edf17',
        wsHost: 'ws-quiniela-millonaria-staging.betnplayapp.com',
        wsPort: 443,
        wssPort: 443,
        forceTLS: true,
        enabledTransports: ['ws', 'wss']
    });
  
    window.Echo.channel('millionaire_pool').listen('.total_pool_updated', (data) => {
      countUp.update(data.users_total_pool);
    });

    loadData();
});

window.mistickets = function (){
  window.location.href = "mistickets.html?token="+token;
}

window.resultados = function (){
  window.location.href = "resultados.html?token="+token;
}

async function loadData() {
    // Objeto con los datos del cuerpo de la solicitud
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          tok: token
        })
    };

    await fetch(api, options)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(result => {
            if(result.success){

              if(result.data.draws.length > 0){
                draws = result.data.draws;
                drawOpen = draws[0];

                $('#sorteo').text(drawOpen.name);

                countUp.update(drawOpen.users_total_pool);
                
                getGames();
              } else {
                
                Swal.fire({
                  icon: "error",
                  title: "Lo sentimos...",
                  html: "<h5 style='color: white;'>No hay sorteos activos.</h5>",
                  allowOutsideClick: false, // Evita que se hagan clics fuera del cuadro de diálogo
                  showCancelButton: false,
                  showConfirmButton: false,
                  showDenyButton: false
                });

              }
            } else {
              errorToken(result);
            }
        })
        .catch(error => {
          console.error('There was a problem with the fetch operation:', error);
        });
}



//Funcion para los juegos
window.selectImage = function(element) {
    // Verificar si la imagen está seleccionada
    var isSelected = element.classList.contains('game-selected');
    
    if(imgSelected.length === 6){
  
      if(isSelected){
  
        //Elimino el item si ya esta seleccionado y ya hay 6 selecciones
        let index = imgSelected.findIndex((res) => res == element.id);
        imgSelected.splice(index, 1);
        element.classList.remove("game-selected");
  
      } else {
        //No continuo si ya hay mas de 6 items seleccionados
        return;
      }
  
    } else {
  
      if(isSelected){
  
        //Elimino los items seleccionados
        let index = imgSelected.findIndex((res) => res == element.id);
        imgSelected.splice(index, 1);
        element.classList.remove("game-selected");
  
      } else {
  
        //Agrego los items seleccionados
        imgSelected.push(element.id);
        element.classList.add("game-selected");
  
        //Si ya hay 6 seleccionados muestro el mensaje
        if(imgSelected.length === 6){
          //Asigno items a variable temporal
          detailTicketImg = imgSelected;
          createSelectionImagen();
        }
      }
    }
}

function createSelectionImagen(){

    formattedDateTime = cargarFechaYHora();

    let html = '';
  
    html+= `<div class="row mb-3">
      <div class='col-12'>
        <img src="./static/img/logogrande.webp"  width="250px"/>
      </div>
    </div>
    <div class="row">
      <div class='col-12'>
        <p style="color: white" >
          Fecha / Hora <br/>
          ${formattedDateTime}
        </p>
      </div>
    </div>
    `;
    html+= `<div class="row">`;
    imgSelected.forEach((selected) => {
      html+= `
        <div class='col-2 p-1'>
          <img class="img-modal-selected" src="./static/img/quinelanew/lottoactivo_${String(selected).padStart(2, '0')}.webp" /><br/>
          <h3>${selected}</h3>
        </div>
      `;
    });
    html+= `</div>`;

    //Si hay uno o mas sorteos
    if(draws.length > 1){
      html+=`
      <div class="row mt-4 mb-4">
        <div class="col-12">
          <h1 class="text-center" style="font-size: 26px;">¿Deseas jugar para el sorteo de la noche?</h1>
          <h3 class="text-center mt-3" style="font-size: 20px;">Tiene un costo de 25. VES adicional</h3>
          <div class="text-center form-switch">
            <input class="form-check-input" type="checkbox" role="switch" id="secondTicket" style="height: 2rem; width: 4rem;">
          </div>
        </div>
      </div>
      `;
    }

    html+= `<h3 style="font-size: 30px;">¿Esta seguro que quieres jugar?</h3><h5 style="color: white;">El valor para cada sorteo es de 25. VES</h5>`;
  
    Swal.fire({
      html: html,
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
      allowOutsideClick: false, // Evita que se hagan clics fuera del cuadro de diálogo
      confirmButtonColor: "#02ab43",
      cancelButtonColor: "#d33",
      showClass: {
        popup: `
        animate__animated
        animate__fadeInUp
        animate__faster
        `
      },
      hideClass: {
        popup: `
        animate__animated
        animate__fadeOutDown
        animate__faster
        `
      }
    }).then((result) => {
      if (result.isConfirmed) {
        sendGame();
      }
    });
}
  
function removeSelections(){
    imgSelected = [];
  
    // Obtener todos los elementos que tienen la clase "tu-clase"
    var elementos = document.querySelectorAll('.game-selected');
  
    // Iterar sobre cada elemento y remover la clase
    elementos.forEach(function(elemento) {
      elemento.classList.remove('game-selected');
    });
}

function sendGame(){

    // Datos a enviar en la solicitud POST
    const data = {
        tok: token,
        numbers: imgSelected,
        id: drawOpen.id,
        idSecondTicket: (document.getElementById('secondTicket') !== null) ? (document.getElementById('secondTicket').checked) ? draws[1].id : null : null
    }

    const options = {
      method: 'POST',
      headers: {
      'Content-Type': 'application/json',
      },
      body: JSON.stringify(data) // Convertir los datos a formato JSON
    };
  
    // Realizar la llamada fetch
    fetch(api+'/create', options)
        .then(response => {
            if (!response.ok) {
            throw new Error('Network response was not ok');
            }
            return response.json(); // Parsear la respuesta como JSON
        })
        .then(result => {
                if(result.success){

                    let html = ``;

                    result.data.res.forEach(element => {
                      html += `
                        <h3>${element.sorteo} - # ${element.ticket_number}</h3>
                      `;
                    });

                    Swal.fire({
                        html: `<h4 style="color: white; margin-bottom: 20px;">
                            ${result.msg}
                            <br/>Suerte !
                          </h4>${html}`,
                        icon: "success",
                        confirmButtonText: "Cerrar",
                        allowOutsideClick: false, // Evita que se hagan clics fuera del cuadro de diálogo
                        confirmButtonColor: "#02ab43",
                    }).then((res) => {
                        if (res.isConfirmed) {
                            removeSelections();
                        }
                    });
                } else {
                    errorToken(result);
                }
        })
        .catch(error => {
          console.error('There was a problem with the fetch operation:', error);
        });
  }

window.detailTicket = function(index) {
  detailTicketGlobal(index, listItems);
}


//Obtener los tickets Jugados
function getGames(){
    // Obtener una referencia al elemento row donde se agregarán los tickets
    const listaTickets = document.getElementById('tickets');
    listaTickets.innerHTML = "";

    // Datos a enviar en la solicitud POST
    const data = {
        tok: token
    }

    const options = {
      method: 'POST',
      headers: {
      'Content-Type': 'application/json',
      },
      body: JSON.stringify(data) // Convertir los datos a formato JSON
    };

    // Llamada a la API para obtener los datos de los tickets
    fetch(api+'/tickets', options)
    .then(response => response.json())
    .then(result => {
        if(result.success){
          
          if(result.data.length > 0){
            listItems = result.data;
    
            // Iterar sobre los datos de los tickets y crear los elementos de la lista
            result.data.forEach((ticket, index) => {
                // Crear un nuevo elemento de columna para el ticket
                const columnaTicket = document.createElement('div');
                columnaTicket.classList.add('col-12', 'col-sm-6', 'col-md-4', 'col-lg-3');
    
                // Crear el contenido del ticket
                columnaTicket.innerHTML = `
                <div class="card mb-4">
                    <div class="card-body">
                    <h5 class="card-title text-center mb-0">
                      <i class="dorado fa-solid fa-ticket"></i> Ticket <br/> <span class="dorado">${ticket.sorteo}</span>
                    </h5>
                    </div>
                    <ul class="list-group list-group-flush">
                    <li class="list-group-item"><i class="dorado fa-solid fa-hashtag"></i> &nbsp; ${ticket.ticket_number}</li>
                    <li class="list-group-item"><i class="dorado fa-solid fa-user"></i> &nbsp; ${ticket.user_name}</li>
                    <li class="list-group-item bold"><i class="dorado fa-solid fa-money-bill"></i> &nbsp; ${ticket.amount} ${ticket.currency}</li>
                    <li class="list-group-item"><i class="dorado fa-solid fa-calendar"></i> &nbsp; ${ticket.date_time}</li>
                    <li class="list-group-item"><i class="dorado fa-solid fa-check"></i> &nbsp; Aciertos <span class="bold"> &nbsp; ${ticket.hits}</span></li>
                    </ul>
                    <div onclick="detailTicket(${index})" class="card-body text-center" style="background: -webkit-linear-gradient(bottom, #fdb125 0%, #e07e1e 18%, #fcb100 45%); cursor: pointer;">
                      <span  style="color: black; font-size: 20px;">VER DETALLE</span>
                    </div>
                </div>
                `;
        
                // Agregar la columna del ticket al elemento row
                listaTickets.appendChild(columnaTicket);
            });
          } else {
            const columnaTicket = document.createElement('div');
            columnaTicket.classList.add('col-12');
            columnaTicket.innerHTML = `
            <div class="text-center" style="margin-top: 1rem;">
              <i class="fa-solid fa-ticket gris-claro" style="font-size: 2rem;"></i>
              <h3>
                No hay juegos para esta fecha.
              </h3>
            </div>
            `;
            listaTickets.appendChild(columnaTicket);
          }

          $('#loader2').hide();

        } else {
          errorToken(result);
        }

    })
    .catch(error => console.error('Error al obtener los tickets:', error));
  }

function errorToken(result){
    Swal.fire({
        icon: "error",
        title: "Lo sentimos...",
        html: "<h5 style='color: white;'>Por favor vuelve a iniciar sesión</h5>",
        allowOutsideClick: false, // Evita que se hagan clics fuera del cuadro de diálogo
        confirmButtonText: "Cerrar",
        showConfirmButton: true,
        showDenyButton: false
    }).then(() => {
        if (result.home) {
            window.location.href = result.home;
        }
    });
}